import React from 'react';
import { Tag, Tooltip } from 'antd';
import type { ItineraryPortCallDto } from '@client/screens/estimates/details/helpers/types';
import EstimatedActualTag from '@client/components/EstimatedActualTag';
import { isEtdSetManually } from '../utils/setEtd';

const DateBadge = ({ entry, type }: { entry: ItineraryPortCallDto; type: string }) => {
	let letter = 'Est';

	let dateType = 'estimated';

	if (type === 'arrival' && entry.arrivalDate != null) {
		dateType = 'actual';
	}

	if (type === 'departure' && entry.departureDate != null) {
		dateType = 'actual';
	}

	if (type === 'arrival' && dateType === 'estimated' && entry.mastersEta != null) {
		dateType = 'estimatedMastersEta';
	}

	if (type === 'departure' && isEtdSetManually(entry)) {
		return (
			<Tooltip title="ETD was set manually">
				<Tag color="lightblue" data-testid="manual-etd-tag">Set ETD</Tag>
			</Tooltip>
		);
	}

	switch (dateType) {
		case 'actual':
			letter = 'Act';
			break;
		case 'estimatedMastersEta':
			letter = 'M. ETA';
			break;
		default:
			letter = 'Est';
			break;
	}

	if (dateType === 'estimatedMastersEta') {
		return (
			<Tag color="lightblue">{letter}</Tag>
		);
	}
	
	return <EstimatedActualTag estimated={letter === 'Est'} />;

};

export default DateBadge;
